module.exports = __webpack_public_path__ + "img/ic_alarm_clock_3.4ae61dc1.png";